import { parseJwt } from "./parseJWT";
import { usePersistStore } from "../../store/persistStore";
import { useAuthorizationStore } from "../../store/authorizationStore";

export function tokenExpiresAt(token: unknown): number | undefined {
  if (typeof token !== "string" || !token.trim() || token.split(".").length !== 3) {
    return;
  }

  try {
    const { exp } = parseJwt(token);
    if (typeof exp === "number" && Number.isFinite(exp) && exp > 0) {
      return exp * 1000;
    }
  } catch (_error) { /* Malformed JWT. */ }
}

export const isActiveToken = (token: unknown): token is string => (tokenExpiresAt(token) ?? 0) > Date.now();

export function authorizationToken() {
  const auth = useAuthorizationStore.getState();
  if (auth.version === "keycloak") {
    return isActiveToken(auth.token) ? auth.token : undefined;
  }

  const legacy = usePersistStore.getState();
  return legacy.deviceJWT ?? legacy.jwt;
}
